// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_FSj","cls2":"ImpactHubModal-cls2_Txr ImpactHubModal-cls1_FSj"};